import React from 'react';
import { Document, Page } from '@react-pdf/renderer';
import Header from './TranscriptHeader';
import Footer from './TranscriptFooter';
import TranscriptTable from './TranscriptTable';
import { paginate } from '../../Transcript/TranscriptUtils';
import styles from '../../Transcript/TranscriptStyles';

const TranscriptMyDocument = ({ data,firstName,lastName,userName,dob  }) => {
  const pages = paginate(data);
  const completedDates = data.map(item => new Date(item.completeddate));
  const minDate = new Date(Math.min(...completedDates));
  const maxDate = new Date(Math.max(...completedDates));

  return (
   
    
    <Document>
      {pages.length > 0 ? (
pages.map((chunk, pageIndex) => (
        <Page key={pageIndex} style={styles.page}>
          <Header minDate={minDate} maxDate={maxDate} firstName={firstName} lastName={lastName} userName={userName} dob={dob} />
          <TranscriptTable chunk={chunk} />
          <Footer minDate={minDate} maxDate={maxDate} />
        </Page>
      ))) : (
      <Page key={0} style={styles.page}>
        <Header
          minDate={minDate}
          maxDate={maxDate}
          firstName={firstName}
          lastName={lastName}
          userName={userName}
          dob={dob}
        />
        <TranscriptTable chunk={[]} />
        <Footer minDate={minDate} maxDate={maxDate} />
      </Page>
    )}
    </Document>
  );
};

export default TranscriptMyDocument;

